import React from 'react';
import { TextField } from 'react-admin';

import Datagrid from '../common/Datagrid';
import DateField from '../common/fields/DateField';
import ResourceLinkField from '../common/fields/ResourceLinkField';
import RecordSplitButton from '../common/buttons/RecordSplitButton';
import PeppolStatusField from './fields/PeppolStatusField';


const AddressRow = ({ children, ...props }) => (
	<Datagrid {...props}>
		<ResourceLinkField label="Name" sortBy="name" resource="addresses">
			<TextField source="name" />
		</ResourceLinkField>
		<ResourceLinkField label="Customer" source="customer" resource="customers" sortBy="customer_id">
			<TextField source="name" />
		</ResourceLinkField>
		<TextField source="email" />
		<TextField source="full_address" />
		<TextField source="vat_number" />
		<PeppolStatusField label="PEPPOL Status" />
		<DateField source="updated_at" />
		<RecordSplitButton />
		{children}
	</Datagrid>
);

export default AddressRow;